/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PasskeyRegistrationOptionsResponse { 
    /**
     * Challenge casuale codificato in Base64URL
     */
    challenge: string;
    /**
     * Identificativo della Relying Party (dominio)
     */
    rp_id: string;
    /**
     * Nome della Relying Party
     */
    rp_name: string;
    /**
     * Identificativo univoco dell'utente codificato in Base64URL
     */
    user_id: string;
    /**
     * Nome utente (email)
     */
    user_name: string;
}